import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ContextMenuComponent, ContextMenuModule, ContextMenuService } from '@perfectmemory/ngx-contextmenu';
import { EncodingPillBaseComponent } from '../encoding-field/encoding-pill-base.component';

@Component({
  standalone: true,
  imports: [CommonModule, ContextMenuModule, EncodingPillBaseComponent],
  selector: 'mode-encoding-field-multiple',
  templateUrl: './encoding-field-multiple.component.html',
})
export class EncodingFieldMultipleComponent {
  @Input() isValidMultiple = true;

  @Output() remove = new EventEmitter();

  @ViewChild(ContextMenuComponent) public menu: ContextMenuComponent | undefined;

  constructor(public contextMenuService: ContextMenuService) {}

  showContextMenu($event: MouseEvent) {
    this.contextMenuService.show.next({
      // Optional - if unspecified, all context menu components will open
      contextMenu: this.menu,
      event: $event,
      item: undefined,
    });
    $event.preventDefault();
    $event.stopPropagation();
  }

  removeField(): void {
    this.remove.emit();
  }
}
